import React, { useState } from 'react'
import {
  ContainerTab,
  Tabs,
  Item,
} from 'homepage/presentation/components/Tab/Tab.style'
import { PRODUCT_TYPE } from 'domain/enums'
import { Typography } from '@creditas-ui/react'
import { eventTrackService } from 'shared/application/services/EventTrackService'
import { getAgencyPermissionsInformation } from 'shared/infrastructure/storage'

const Tab = ({ handleCollateralFilter, productType }) => {
  const [activeTab, setActiveTab] = useState(productType)
  const permissions = getAgencyPermissionsInformation()
 
  const handleTabClick = key => {
    eventTrackService.track('form_button_clicked', {
      category: 'behavior',
      journey: 'discovery',
      element_name: key,
    })
    setActiveTab(key)
    handleCollateralFilter({ value: key })
  }

  return (
    <ContainerTab>
      <Tabs>
        {Object.keys(PRODUCT_TYPE).map((key) => (
            <React.Fragment key={key}>
              {permissions[key] && (
                <Item key={key} active={activeTab === key}>
                  <button onClick={() => handleTabClick(key)} data-testid={key}>
                    <Typography variant="bodyMdRegular">
                      {PRODUCT_TYPE[key]}
                    </Typography>
                  </button>
                </Item>
              )}
            </React.Fragment>
          ))}
      </Tabs>
    </ContainerTab>
  )
}

export { Tab }
